
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/privacy/version/[version]",
      function () {
        return require("private-next-pages/[lang]/privacy/version/[version].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/privacy/version/[version]"])
      });
    }
  